import { Injectable } from '@angular/core';

/**
 * Pour les vérifications de formulaire
 */
@Injectable()
export class FormVerificationService {

    /**
     * Regex utilisé pour valider un montant
     */
    public static readonly REGEX_MONTANT = /^(\d+)(,\d{1,}|\.\d{1,})?$/;

    /**
     * Vérification de la validité d'un prix
     * @param rawData valeur brute
     * @returns si la valeur est OK
     */
    public isDataPriceValid(rawData: string): boolean {
        if(rawData === '') {
        // Champ vide, le caractère "required" a normalement été géré en amont
        return true;
        }

        // On vérifie si c'est bien un format prix (avec une virgule ou un point en tant que séparateur de décimales)
        const matches = String(rawData).match(FormVerificationService.REGEX_MONTANT);
        return(matches !== null);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/form-verification.service.ts